import { callApiWithAuthorization } from "../CallApi";

export async function getSharedLookups(projectId) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/getSharedLookups`);
    const response = await request.json();
    return response;
}

export async function createSharedLookup(projectId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/createSharedLookup`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties),
    });
    const response = await request.json();
    return response;
}

export async function updateSharedLookup(sharedLookupId, projectId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/updateSharedLookup/${sharedLookupId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

